<template>
  <b-overlay :show="showOverlay" rounded="sm">

    <!--    Editor Modal  -->
    <b-modal id="modal-Editor" centered ok-only ok-title="ثبت" title="افزودن کد html"
      @ok.preventDefault()="customButtonClick">
      <b-row>
        <span class="mx-1 mb-1">کد HTML خود را در اینجا قرار دهید</span>
        <b-col cols="12">
          <textarea v-model="rawHTML" class="form-control"></textarea>
        </b-col>
      </b-row>
    </b-modal>

    <component :is="product === null ? 'div' : 'b-card'">
      <b-tabs v-if="product !== null">
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon class="mr-0 mr-sm-50" icon="ClipboardIcon" size="16" />
            <span class="d-none d-sm-inline">اطلاعات محصول</span>
          </template>

          <!-- Media -->
          <b-media class="my-2">
            <template>
              <b-avatar ref="previewEl" :src="base64ImageSrc" rounded size="300px" />
            </template>
            <div class="d-flex flex-wrap mt-1">
              <b-button variant="primary" @click="$refs.refInputEl.click()">
                <input ref="refInputEl" class="d-none" type="file" @input="makeBase64Pic">
                <span class="d-none d-sm-inline">+ عکس</span>
                <feather-icon class="d-inline d-sm-none" icon="EditIcon" />
              </b-button>
              <b-button class="ml-1" variant="outline-secondary" @click="deleteProductPic()">
                <span class="d-none d-sm-inline">حذف</span>
                <feather-icon class="d-inline d-sm-none" icon="TrashIcon" />
              </b-button>
            </div>
          </b-media>

          <div>

            <b-form>
              <b-row>

                <!-- Field:  Title -->
                <b-col cols="12" md="4">
                  <b-form-group label="عنوان" label-for="Title">
                    <b-form-input id="Title" v-model="product.title" />
                  </b-form-group>
                </b-col>

                <!-- Field: isFree -->
                <b-col cols="12" md="4">
                  <b-form-group label="وضعیت" label-for="user-status">
                    <v-select v-model="product.isFree" :clearable="false" :options="isFreeOptions"
                      :reduce="val => val.value" input-id="user-status" />
                  </b-form-group>
                </b-col>

                <!-- Field:  price -->
                <b-col v-if="!product.isFree" cols="12" md="4">
                  <b-form-group label="قیمت (تومان)" label-for="price">
                    <b-form-input id="price" v-model="product.price" />
                  </b-form-group>
                </b-col>

                <!-- Field:  beforeDiscount -->
                <b-col cols="12" md="4">
                  <b-form-group label="قیمت قبلی (خط خورده)" label-for="beforeDiscount">
                    <b-form-input id="beforeDiscount" v-model="product.beforeDiscount" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <div class="product-categories mt-2">
                    <span class="filter-title">
                      نمایش محصول در باندل
                    </span>
                    <b-form-checkbox v-model="product.showOnlyInBundle" inline name="check-button" switch>
                    </b-form-checkbox>
                  </div>
                </b-col>

                <!-- Field:  subtitle -->
                <b-col cols="12">
                  <b-form-group label="سوتیتر" label-for="subtitle">
                    <b-form-input id="subtitle" v-model="product.subtitle" />
                  </b-form-group>
                </b-col>

                <!--   Field: seoDescription     -->
                <b-col cols="12">
                  <b-form-group label="توضیحات (سئو)" label-for="seoDescription">
                    <b-form-textarea id="seoDescription" v-model="product.seoDescription"></b-form-textarea>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group class="mb-2" label="توضیحات" label-for="product-content">
                    <ckEditorMain ref="editorContent" :defaultContent="product.description"
                      @getEditorContent="setEditorContent">
                    </ckEditorMain>
                  </b-form-group>
                  <textarea v-if="showHTML" id="product-content" v-model="rawHTML" class="form-control mb-2 " cols="30"
                    dir="ltr" name="textArea" rows="10"></textarea>
                </b-col>

                <!-- Field: productCategoryId -->
                <b-col v-if="categories !== null" cols="12" md="4">
                  <b-form-group label="دسته بندی" label-for="productCategoryId">
                    <v-select v-model="product.productCategoryId" :clearable="false" :options="categories"
                      :reduce="name => name.productCategoryId" disabled input-id="productCategoryId" label="name" />
                  </b-form-group>
                </b-col>

                <!-- Field: type -->
                <b-col cols="12" md="4">
                  <b-form-group label="انتخاب نوع محصول" label-for="type">
                    <v-select v-model="product.type" :clearable="false" :options="types" :reduce="val => val.value"
                      disabled input-id="productCategoryId" />
                  </b-form-group>
                </b-col>
                <!-- Field: courseId -->
                <b-col v-if="product.type === 1" cols="12" md="4">
                  <b-form-group label="انتخاب دوره" label-for="type">
                    <v-select v-model="product.courseId" :options="courses" label="name" :reduce="name => name.courseId"
                      :clearable="false" input-id="productCategoryId" />
                  </b-form-group>
                </b-col>

                <b-col v-if="product.type === 8" cols="12">
                  <b-row>
                    <b-col v-for="(item, idx) in product.productInfos" :key="idx" cols="12">
                      <b-row>
                        <b-col cols="12" md="8">
                          <b-form-group :label="` توضیحات آیتم شماره ${idx + 1}`" label-for="seoDescription">
                            <b-form-textarea v-model="item.title"></b-form-textarea>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                          <b-form-group :label="` آیکون آیتم شماره ${idx + 1}`" label-for="seoDescription">
                            <b-form-textarea v-model="item.icon"></b-form-textarea>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="نوع خدمات مالیاتی" label-for="taxServiceType">
                    <v-select v-model="product.taxServiceType" :clearable="true" :options="taxTypes"
                      :reduce="label => label.value" input-id="taxServiceType" label="label" />
                  </b-form-group>
                </b-col>

              </b-row>
            </b-form>

            <b-button :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2" variant="primary" @click="updateProduct">
              ثبت
            </b-button>
          </div>

        </b-tab>

      </b-tabs>
    </component>

    <b-card class="mt-5">

      <b-row>
        <b-col cols="12">
          <h2>ویرایش وضعیت موجودیت</h2>
          <b-row>
            <!-- Field: trailerFile -->
            <b-col cols="12">

              <!-- Field: isAvailable -->
              <b-col cols="12" md="4">
                <b-form-group label="موجودیت" label-for="isAvailable">
                  <v-select v-model="isAvailable" :clearable="false" :options="isAvailableOptions"
                    :reduce="val => val.value" input-id="isAvailable" />
                </b-form-group>
                <b-button variant="primary" @click="changeProductAvailablity">
                  <span class="d-none d-sm-inline">ویرایش وضعیت</span>
                </b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mt-5">

      <b-row>
        <b-col cols="12">
          <h2>تریلر</h2>
          <b-row>
            <!-- Field: trailerFile -->
            <b-col v-if="base64Trailer === '' || base64Trailer === null" cols="12">
              <b-button class="mt-2 col-6" variant="warning" @click="$refs.refInputEl2.click()">
                <input ref="refInputEl2" class="d-none" type="file" @change="select">
                <span class="">{{ file ? file.name : "اتنتخاب تریلر" }}</span>
              </b-button>

              <b-button :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                class="mt-2 mb-sm-0 ml-2 mr-sm-1 col-12 col-md-2" variant="primary" @click="upload">
                ثبت
              </b-button>

              <b-progress v-if="uploaded !== 0 && uploaded !== 100" :value="uploaded" class=" mt-2" max="100"
                variant="primary" />

            </b-col>

            <b-col v-else cols="12">
              <video class="col-10" controls style="max-height: 30rem;">
                <source :src="base64Trailer" size="" type="" />
              </video>

              <b-button :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                class="mt-1 mb-sm-0 ml-1 mr-sm-1 col-2 col-md-2" variant="danger" @click="deleteTrailer">
                حذف تریلر
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

    </b-card>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTab,
  BTabs,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select'
import {
  ProductCategoryGetAllRequest,
  ProductChangeProductAvailablityRequest, ProductCourseGetAllRequest,
  ProductGetByIdRequest,
  ProductUpdateRequest
} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

// Quill
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { MediaDeleteMediaByPictureUrlRequest } from "@/libs/Api/Media";
import axios from "axios";
import { getUserData } from "@/auth/utils";
import Helper from "@/libs/Helper";
import ckEditorMain from "@/views/components/ckEditorMain";


export default {
  title: 'اطلاعات محصول - پنل ادمین ذهن آرایی',
  data() {
    return {
      product: null,
      showOverlay: false,
      // productId: this.$route.params.id || this.$route.path.split('/')[3],
      base64ImageSrc: null,
      categories: null,
      showHTML: false,
      courses: [],
      snowOption: {
        theme: 'snow',
        modules: {
          toolbar: '#toolbar'
        },
      },
      base64Trailer: null,
      rawHTML: '',
      isFreeOptions: [
        { label: 'رایگان', value: true },
        { label: 'پولی', value: false }
      ],
      types: [
        { label: 'دوره', value: 1 },
        { label: 'فیلم', value: 2 },
        { label: 'فایل', value: 3 },
        { label: 'پادکست', value: 4 },
        { label: 'پکیج', value: 7 },
        { label: 'تست روانشناسی', value: 8 },
      ],
      isAvailableOptions: [
        { label: 'موجود', value: true },
        { label: 'ناموجود', value: false }
      ],
      taxTypes: [
        { label: 'تولید محتوای آموزشی تصویری در زمینه مهارت‌های ارتباطی', value: 1 },
        { label: 'تولید محتوای آموزشی تصویری در زمینه رشد فردی', value: 2 },
        { label: 'تولید محتوای آموزشی تصویری در زمینه تحکیم خانواده', value: 3 },
      ],
      isAvailable: null,
      //  Upload
      userToken: getUserData().token,
      errorAlert: false,
      overlay: false,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      file: null,
      chunks: [],
      uploaded: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
    }
  },
  computed: {
    routeParams() {
      return this.$route.params
    },
    productId() {
      return this.$route.params.id || this.$route.path.split('/')[3]
    },
    formData() {
      let formData = new FormData;

      if (this.file !== null) {
        formData.set('file', this.file, `${this.file.name}`);
      }
      return formData;
    },
    config() {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials: true,
        url: Helper.baseUrl + 'api/Product/UploadTrailer?productId=' + this.product.productId,
        headers: {
          'Authorization': 'Bearer ' + this.userToken,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: progressEvent => {
          this.uploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
  },
  async created() {
    await this.loadProductPage();
  },
  watch: {
    async productId(newVal, oldVal) {
      console.log(12)
      if (newVal !== oldVal) {
        await this.loadProductPage();
      }
    }
  },
  methods: {

    async getAllCourses() {
      let _this = this;
      _this.overlay = true;
      let courseData = {
        pageNumber: 0,
        searchCommand: '',
        count: 0
      }
      let productCourseGetAllRequest = new ProductCourseGetAllRequest(_this);
      productCourseGetAllRequest.setParams(courseData);
      await productCourseGetAllRequest.fetch(function (content) {
        _this.courses = content.courses;
        _this.overlay = false;
      }, function (error) {
        _this.overlay = false;
      })
    },
    async getProduct() {
      let _this = this;
      _this.showOverlay = true;

      let productGetByIdRequest = new ProductGetByIdRequest(_this);
      productGetByIdRequest.setId(_this.productId);
      await productGetByIdRequest.fetch(function (content) {
        _this.product = content.product;
        _this.base64ImageSrc = Helper.baseUrl + _this.product.imageFile;
        _this.product.imageFile = '';
        if (_this.product.trailerFile && _this.product.trailerFile !== 'media/gallery/Trailer/') {
          _this.base64Trailer = Helper.baseUrl + _this.product.trailerFile;
          _this.product.trailerFile = '';
        } else {
          _this.product.trailerFile = ''
        }
        ;
        _this.isAvailable = _this.product.available;
        _this.showOverlay = false;
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async changeProductAvailablity() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        productId: _this.productId,
        isAvailable: _this.isAvailable
      }

      let productChangeProductAvailablityRequest = new ProductChangeProductAvailablityRequest(_this);
      productChangeProductAvailablityRequest.setParams(data);
      await productChangeProductAvailablityRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.showOverlay = false;
        _this.getProduct()
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async getAllProductCategories() {
      let _this = this;
      _this.showOverlay = true;
      let defaultGetData = {
        pageNumber: 0,
        count: 0,
      }

      let productCategoryGetAllRequest = new ProductCategoryGetAllRequest(_this);
      productCategoryGetAllRequest.setParams(defaultGetData);
      await productCategoryGetAllRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.categories = content.productCategories;
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async updateProduct() {
      let _this = this;
      _this.showOverlay = true
      _this.product.trailerFile = '';

      let productUpdateRequest = new ProductUpdateRequest(_this);
      productUpdateRequest.setParams(_this.product);
      await productUpdateRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getProduct()
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async readAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onerror = reject;
        fr.onload = () => {
          resolve(fr.result.split(",")[1]);
        }
        fr.readAsDataURL(file);
      });
    },
    async makeBase64Pic(e) {
      const _this = this;
      let file = e.target.files[0]
      _this.base64ImageSrc = URL.createObjectURL(file)
      _this.product.imageFile = await _this.readAsDataURL(file);
    },
    deleteProductPic() {
      this.product.imageFile = '';
      this.base64ImageSrc = null
    },
    select(event) {
      this.file = event.target.files.item(0);
    },
    upload() {
      this.showOverlay = true;
      axios(this.config).then(response => {

        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `فایل با موفقیت آپلود شد.`,
          },
        })
        // this.$router.push({name:'apps-post-list'})
        this.showOverlay = false;
        _this.getProduct()
      }).catch(error => {
        this.showOverlay = false;
        // this.errorAlert = true;
        console.log(error);
      });
    },
    async makeBase64(e) {
      const _this = this;
      let file = e.target.files[0];
      _this.product.trailerFile = await _this.readAsDataURL(file);
    },
    customButtonClick() {
      this.showHTML = !this.showHTML

      const editor = document.querySelector('.ql-editor')
      if (editor.classList.contains('d-none')) {
        this.product.description = this.rawHTML
        editor.classList.remove('d-none')

      } else {
        this.rawHTML = this.product.description
        editor.classList.add('d-none')
      }
    },
    async deleteTrailer() {
      let _this = this;
      _this.showOverlay = true;

      let pictureUrl = _this.base64Trailer.split('media/gallery/Trailer/')[1];

      let data = {
        pictureUrl: pictureUrl
      }

      let mediaDeleteByPictureUrlRequest = new MediaDeleteMediaByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setParams(data);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getProduct()
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    setEditorContent(content) {
      this.product.description = content;
    },
    async loadProductPage() {
      await this.getProduct();
      await this.getAllProductCategories();
      await this.getAllCourses();
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BFormCheckbox,
    // BSV
    BCard,
    BRow,
    BCol,
    BButton,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    BModal,
    BProgress,
    vSelect,
    ckEditorMain,
  },

}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce-details.scss";
</style>
